import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import { StatusCard } from '@components/StatusCard';
import { Translate } from '@hooks/useI18n';
import { CustomerAgreementSigningOverview } from '../types';
import { getPillLabel, getPillVariant, getStatus } from './utils';

interface ICustomerAgreementStatusCard {
  customerAgreementSigningOverview: CustomerAgreementSigningOverview;
  translate: Translate;
}

const getHasDownloadedAgreementLabel = (
  hasDownloaded: boolean | undefined,
  translate: Translate,
) =>
  translate(
    hasDownloaded
      ? 'LABEL.CUSTOMER_AGREEMENT_HAS_BEEN_PRINTED'
      : 'LABEL.CUSTOMER_AGREEMENT_HAS_NOT_BEEN_PRINTED',
  );

const getHasSignedAgreementLabel = (
  hasUploaded: boolean | undefined,
  translate: Translate,
) =>
  translate(
    hasUploaded
      ? 'LABEL.SIGNED_CUSTOMER_AGREEMENT_HAS_BEEN_UPLOADED'
      : 'LABEL.SIGNED_CUSTOMER_AGREEMENT_HAS_NOT_BEEN_UPLOADED',
  );

export const CustomerAgreementStatusCard = ({
  customerAgreementSigningOverview,
  translate,
}: ICustomerAgreementStatusCard) => {
  const {
    hasDownloadedAgreement,
    hasUploadedSignedAgreement,
    isManualSigningRequired,
  } = customerAgreementSigningOverview ?? {};

  const hasCompletedProcess =
    hasDownloadedAgreement && hasUploadedSignedAgreement;

  return isManualSigningRequired ? (
    <StatusCard
      description={translate(
        'LABEL.THE_CUSTOMER_AGREEMENT_MUST_BE_PRINTED_SIGNED_UPLOADED',
      )}
      pillLabel={getPillLabel(hasCompletedProcess, translate)}
      pillVariant={getPillVariant(hasCompletedProcess)}
      statuses={[
        {
          icon: <DownloadIcon />,
          label: getHasDownloadedAgreementLabel(
            hasDownloadedAgreement,
            translate,
          ),
          type: getStatus(hasDownloadedAgreement),
        },
        {
          icon: <CloudUploadIcon />,
          label: getHasSignedAgreementLabel(
            hasUploadedSignedAgreement,
            translate,
          ),
          type: getStatus(hasUploadedSignedAgreement),
        },
      ]}
      title={translate('LABEL.CUSTOMER_AGREEMENT')}
    />
  ) : null;
};
